import React from "react";
import moment from "moment";
function NotificationTile({
  message,
  created_at,
  newNotification,
  notificationType,
}) {
  return (
    <div
      className={`notification-tile-container ${notificationType}-class ${
        !newNotification && "read"
      }`}
    >
      <p>{message}</p>
      <span className="notification-time">{moment(created_at).fromNow()}</span>
    </div>
  );
}

export default NotificationTile;
